import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Fragment, useEffect, useState, useTransition } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Constants/RouteUrls";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange } from "Utils/Common";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ControlledForm from "Components/ControlledForm";
import authApi from "Service/Auth.api";
import ImgPath from "Constants/Imgs";
import { registrationFormData, skillDataFormArr } from "./Data";
import { SkillArr } from "Constants/Arrays";
import { HandleChangeProps } from "DataTypes/Common";
import { CloseOutlined } from "@mui/icons-material";
import ColorData from "Components/CstmTheme/ColorData";

export interface skillFormArrType {
  id: number;
  skillFormArr: FormDataType[];
}
const ProfessionalRegister = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormDataType[]>(
    JSON.parse(JSON.stringify(registrationFormData()))
  );
  const [selectedDocuments, setSelectedDocuments] = useState<File[]>([]);
  const [documentsUploaded, setDocumentsUploaded] = useState<boolean>(false);
  const [formData1, setFormData1] = useState<
    | {
        id: number;
        skillFormArr: FormDataType[];
      }[]
    | []
  >([
    {
      id: 1,
      skillFormArr: skillDataFormArr,
    },
  ]);
  const [emailData, setEmailData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const [contactData, setContactData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleSendOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType == "email") {
      const res = await authApi.emailSendOtp({
        email: emailData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    } else {
      const res = await authApi.mobileSendOtp({
        mobileNumber: contactData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setContactData({
          fieldVal: contactData.fieldVal,
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    }
  };
  const handleVerifyOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType == "email") {
      const res = await authApi.verifyOtp({
        mobileNumber: null,
        email: emailData.fieldVal,
        otp: emailData.otpVal,
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: emailData.otpVal,
          otpVerified: true,
        });
      }
    } else {
      const res = await authApi.verifyOtp({
        mobileNumber: contactData.fieldVal,
        email: null,
        otp: contactData.otpVal,
      });
      if (res?.success) {
        setContactData({
          fieldVal: contactData.fieldVal,
          otpSend: true,
          otpVal: contactData.otpVal,
          otpVerified: true,
        });
      }
    }
  };

  const handleRegister = async () => {
    const selectedRoles = formData[9]?.dropValue;
    const selectedSkills = formData1.map((el) => {
      return {
        skillId: el.skillFormArr[0].dropValue,
        // rating: el.skillFormArr[1].value,
        numberOfExperienceYears: el.skillFormArr[1].value,
        description: el.skillFormArr[2].value,
        servesPanIndia: el.skillFormArr[3].dropValue === "yes" ? true : false,
        servesStates: el.skillFormArr[4].dropValue,
      };
    });
    const payload = {
      firstName: formData[0].value,
      lastName: formData[1].value,
      address: formData[2].value,
      city: formData[3].value,
      state: formData[4].dropValue,
      postalCode: formData[5].value,
      dateOfBirth: formData[6].value,
      description: "test",
      password: formData[7].value,
      highestQualification: formData[8].value,
      profilePicturePath: "",
      email: emailData.fieldVal,
      contactNumber: contactData.fieldVal,
      // userType: "Professional",
      roles: selectedRoles,
      skills: selectedSkills || [],
    };

    const res = await authApi.registerProfessional(payload);
    if (res?.success) {
      navigate(`/${RouteUrls.dashboard}/${RouteUrls.customer}`);
    }
  };

  const handleAddMore: () => void = () => {
    setFormData1((prev) => [
      ...prev,
      {
        id: prev.length > 0 ? prev[prev.length - 1].id + 1 : 1,
        skillFormArr: JSON.parse(JSON.stringify(skillDataFormArr)),
      },
    ]);
  };
  const removeLocationArr: (id: number) => void = (id) => {
    const newArr = formData1.filter((el) => el.id !== id);
    setFormData1(newArr);
  };

  const handleLocationChange: (
    props: HandleChangeProps,
    orderId: number
  ) => void = (props, orderId) => {
    const { value, id } = props;
    const newFormArr: skillFormArrType[] = JSON.parse(
      JSON.stringify(formData1)
    );

    const formArrIndex = newFormArr.findIndex((el) => el.id === orderId);
    if (formArrIndex !== -1) {
      if (id === "servesPan" && value === "yes") {
        newFormArr[formArrIndex].skillFormArr[4].required = false;
        newFormArr[formArrIndex].skillFormArr[4].readOnly = true;
        newFormArr[formArrIndex].skillFormArr[4].dropValue = [];
        newFormArr[formArrIndex].skillFormArr[4].error = false;
        newFormArr[formArrIndex].skillFormArr[4].errorText = "";
      } else {
        newFormArr[formArrIndex].skillFormArr[4].required = true;
        newFormArr[formArrIndex].skillFormArr[4].readOnly = false;
      }
    }
    const newFormObjArr = HandleFormChange(
      props,
      newFormArr[formArrIndex].skillFormArr
    );
    newFormArr[formArrIndex].skillFormArr = newFormObjArr;
    setFormData1([...newFormArr]);
  };

  const handleDocumentSubmission: () => void = async () => {
    // Call Document Submission API here
    if (!emailData.fieldVal || !contactData.fieldVal) {
      alert(
        "Please fill in Email and Contact Number before uploading documents."
      );
      return;
    }

    const formData = new FormData();
    formData.append("emailId", emailData.fieldVal);
    formData.append("mobileNumber", contactData.fieldVal);

    selectedDocuments.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await authApi.uploadProfessionalDocuments(formData);

      if (response?.success) {
        setSelectedDocuments([]);
        setDocumentsUploaded(true);
      } else {
        console.log("Failed to upload documents.");
      }
    } catch (error) {
      console.error("Error uploading documents:", error);
    }
  };

  const handlePasswordToggle = (fieldId: string) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  return (
    <Box sx={{ height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box
          component="img"
          src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
          alt="Logo"
          sx={{
            width: { xs: "150px", sm: "200px", md: "230px" },
            height: { xs: "60px", sm: "80px", md: "83px" },
            objectFit: "contain",
            cursor: "pointer",
            filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
          onClick={() => (window.location.href = "/home.html")}
        />
        <Typography
          component="h1"
          variant="h4"
          sx={{
            flex: 1,
            textAlign: "center",
            color: "primary.main",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          Sign Up as Professional
        </Typography>
        <Box sx={{ width: "180px" }} /> {/* Spacer to balance the layout */}
      </Box>
      <Grid
        container
        component="main"
        sx={{ flex: 1 }}
        alignItems="center"
        justifyContent="center"
      >
        {!isSmallScreen && (
          <Grid
            sx={{
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100%",
            }}
          />
        )}
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 4,
          }}
        >
          <Box
            sx={{
              mx: 4,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box component="form" noValidate sx={{ mt: 1, width: "100%" }}>
              <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
                {formData.map((el: FormDataType) => (
                  <Grid
                    key={el.id}
                    size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
                  >
                    {commonFormSwitch({
                      //   formObj: el,
                      //   onChange: (data) =>
                      //     setFormData(HandleFormChange(data, formData)),
                      // })}
                      formObj: {
                        ...el,
                        onPasswordToggle: el.hasPasswordToggle
                          ? () => handlePasswordToggle(el.id)
                          : undefined,
                      },
                      onChange: (data) =>
                        setFormData(HandleFormChange(data, formData)),
                    })}
                  </Grid>
                ))}
              </Grid>

              <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
                <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <ControlledForm.Input
                    id="email"
                    value={emailData.fieldVal}
                    {...(emailData.otpVerified && {
                      focused: true,
                      borderColor: "success",
                      readOnly: true,
                    })}
                    label="Email"
                    onChange={(value) =>
                      setEmailData({ ...emailData, fieldVal: value as string })
                    }
                  />
                </Grid>
                <Grid
                  key={"emailOtp"}
                  sx={{
                    display: emailData.otpSend === true ? "block" : "none",
                  }}
                  size={{ ...ControlledBoxSizeSwitch(3) }}
                >
                  <ControlledForm.Input
                    id="emailOtp"
                    label="Email OTP"
                    {...(emailData.otpVerified === true && {
                      iconId: "check-icon",
                      infoText: "Email Verified",
                      readOnly: true,
                    })}
                    value={emailData.otpVal}
                    onChange={(value) =>
                      setEmailData({ ...emailData, otpVal: value as string })
                    }
                  />
                </Grid>
                <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <Button
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={() =>
                      emailData.otpSend
                        ? handleVerifyOtp("email")
                        : handleSendOtp("email")
                    }
                  >
                    {emailData.otpSend === true ? "Verify" : "Send OTP"}
                  </Button>
                  <IconButton
                    sx={{ mt: 3 }}
                    title="Reset"
                    onClick={() =>
                      setEmailData(
                        JSON.parse(
                          JSON.stringify({
                            fieldVal: "",
                            otpSend: false,
                            otpVal: "",
                            otpVerified: false,
                          })
                        )
                      )
                    }
                  >
                    <ImgPath.RestoreIcon />
                  </IconButton>
                </Grid>
              </Grid>

              <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
                <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <ControlledForm.Input
                    id="contact"
                    value={contactData.fieldVal}
                    {...(contactData.otpVerified && {
                      focused: true,
                      borderColor: "success",
                      readOnly: true,
                    })}
                    label="Contact"
                    onChange={(value) =>
                      setContactData({
                        ...contactData,
                        fieldVal: value as string,
                      })
                    }
                  />
                </Grid>
                <Grid
                  key={"contactOtp"}
                  sx={{
                    display: contactData.otpSend === true ? "block" : "none",
                  }}
                  size={{ ...ControlledBoxSizeSwitch(3) }}
                >
                  <ControlledForm.Input
                    id="contactOtp"
                    value={contactData.otpVal}
                    {...(contactData.otpVerified && {
                      iconId: "check-icon",
                      infoText: "Contact Number Verified",
                      readOnly: true,
                    })}
                    label="Contact OTP"
                    onChange={(value) =>
                      setContactData({
                        ...contactData,
                        otpVal: value as string,
                      })
                    }
                  />
                </Grid>
                <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <Button
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={() =>
                      contactData.otpSend
                        ? handleVerifyOtp("contact")
                        : handleSendOtp("contact")
                    }
                  >
                    {contactData.otpSend === true ? "Verify" : "Send OTP"}
                  </Button>
                  <IconButton
                    sx={{ mt: 3 }}
                    title="Reset"
                    onClick={() =>
                      setContactData(
                        JSON.parse(
                          JSON.stringify({
                            fieldVal: "",
                            otpSend: false,
                            otpVal: "",
                            otpVerified: false,
                          })
                        )
                      )
                    }
                  >
                    <ImgPath.RestoreIcon />
                  </IconButton>
                </Grid>
              </Grid>

              {formData1.map((el, index) => {
                return (
                  <Fragment>
                    <Box>
                      <Grid
                        container
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                        mt={2}
                        columnSpacing={1}
                        rowSpacing={2}
                      >
                        {el?.skillFormArr?.map((el1) => {
                          return (
                            <Grid
                              key={el.id}
                              size={{ ...ControlledBoxSizeSwitch(el1.boxSize) }}
                              mt={2}
                            >
                              {commonFormSwitch({
                                formObj: el1,
                                onChange: (props) =>
                                  handleLocationChange(props, el.id),
                              })}
                            </Grid>
                          );
                        })}
                        {index !== 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                            }}
                          >
                            {
                              <IconButton
                                title="Delete"
                                onClick={() => removeLocationArr(el.id)}
                              >
                                <CloseOutlined />
                              </IconButton>
                            }
                          </Box>
                        )}
                      </Grid>
                    </Box>
                  </Fragment>
                );
              })}

              <Grid sx={{ mt: 2, mb: 2 }}>
                <Button variant="contained" onClick={handleAddMore}>
                  Add More
                </Button>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",

                  width: "30%",
                }}
              >
                <ControlledForm.Input
                  id="fileSelection"
                  type="file"
                  onChange={(value) =>
                    setSelectedDocuments(typeof value == "object" ? value : [])
                  }
                  label="Upload Professional Qualification Documents"
                  focused={true}
                  readOnly={documentsUploaded}
                  {...(documentsUploaded && {
                    borderColor: "success",
                    infoText: "Documents Uploaded Successfully",
                    iconId: "check-icon",
                  })}
                />

                <Button
                  variant="contained"
                  sx={{
                    ml: 3,
                    backgroundColor: documentsUploaded ? "#4CAF50" : undefined,
                    "&:hover": {
                      backgroundColor: documentsUploaded
                        ? "#43A047"
                        : undefined,
                    },
                  }}
                  onClick={handleDocumentSubmission}
                  disabled={documentsUploaded}
                >
                  {documentsUploaded ? "Upload Documents" : "Upload Documents"}
                </Button>
              </Box>

              <Button
                variant="contained"
                sx={{ mt: 3 }}
                onClick={handleRegister}
                disabled={!emailData.otpVerified && !contactData.otpVerified}
              >
                Sign Up
              </Button>

              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() => navigate(`/${RouteUrls.login}`)}
              >
                Already have an account? Login
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfessionalRegister;
